define('views/parts/chart/pie-chart',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'moment', 'chartjs',
    // src
    'services/app-state',
    // templates
    'text!templates/parts/chart/pie-chart.html',
], function(
    // Libs
    _, Backbone, Mustache, U, moment, Chart,
    // src
    AppState,
    // templates
    TPieChart
) {

    var VPieChart = Backbone.View.extend({

        template: TPieChart,

        initialize: function(opt) {
            this.options = opt || {};

            Chart.defaults.global.responsive = true;

        },

        render: function() {

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            var color = AppState.getBrandColor().hex();
            var context = this.$el.find('canvas').get(0).getContext("2d");

            this.chart = new Chart(context, {
                type: 'pie',
                data: {
                    labels: this.options.labels,
                    datasets: [{
                        data: this.options.data,
                        backgroundColor: this.getDynamicColors(),
                    }]
                },
                options: {
                    defaultColor: color,

                    title: {
                        display: false,
                        text: this.options.title,
                    },
                },
            });

            return this;
        },

        updateChart: function(options) {

            var chart = this.chart,
                data = chart.data,
                chartOpt = chart.options,
                scales = chartOpt.scales,
                xAxes = scales.xAxes[0],
                yAxes = scales.yAxes[0];

            _.extend(data.datasets[0], {
                data: options.data,
                //label: options.datasetUnit,
            });

            data.labels = options.labels;
            this.chart.options.title.text = options.title;

            this.chart.update();
        },

        toggleHelp: function() {
            this.$help.fadeToggle(300);
        },

        getDynamicColors: function() {
            var colors = [],
                r, g, b;

            _.each(this.options.data, function(value) {
                r = Math.floor(Math.random() * 255);
                g = Math.floor(Math.random() * 255);
                b = Math.floor(Math.random() * 255);
                colors.push("rgb(" + r + "," + g + "," + b + ")");
            });

            return colors;
        },

    });

    return VPieChart;

});

